export const TRANSLATIONS_EN = {
  /////////////////////HEADER EN//////////////////////////////
  header: {
    link: [
      "Home", //0
      "Services", //1
      "Portfolio", //2
      "Contact", //3
    ],
  },
  /////////////////////HOME SCREEN EN//////////////////////////////
  translateButton: {
    english: "English",
    spanish: "Spanish",
  },
  /////////////////////HOME SCREEN EN//////////////////////////////
  homeScreen: {
    ///STATIC PAGE CONTENT///
    // titleMain:'*$Website, app, \&$*',
    titleMain: "*$We're experts on $* ",
    title: "*&software.&*",
    titleBody: `;; Our goal is to provide *solutions* for ;; 
        our clients - *not problems*.`,
    subtitle: "*If you can imagine it, ;; $we$ can create it.*",
    subtitleBody: `INOWU specializes in developing bold, beautiful products all while ;;
        sticking to deadlines, so that you can focus on managing your business. ;; ;;
        Our team has more than 10 years of development experience with ;;
        office locations in the United States and Mexico, allowing us to ;;
        work on the same schedule as our clients.`,
    subtitleBtn: "Get a project estimate",
    prevWork: `*Our $previous$ work*`,
    inowu: "*Why work with us?*",
    inowuText: `INOWU has experience working with companies ;;
        in various industries – FinTech, healthcare, ;;
        government, security, Big Data, and more. ;;
        Will you be next?`,
    getEstimate: "$Get a project estimate$",
    testimonialsHead: `*$Hear$ from our ;; past clients*`,
    testimonialsBody: `See what our work has to offer by hearing how INOWU helped
        ;; past clients leverage their business potential.`,
    officesHead: "*Visit our $offices$*",
    cdmxOffice: `*Ciudad de México, México * ;;
        Cto Interior Avenida Río Churubusco 601, Xoco, ;;
        Benito Juárez, 03330 ;; 
        =See on map= ;;
        ;; ;; 
        *Hermosillo, Sonora (HQ)* ;; 
        Bulevar Abelardo L. Rodríguez & Av. Everardo ;;
        Monroy 51, Centro, 83000 ;;
        =See on map=
        ;; ;;
        *Phoenix, Arizona* ;; 
        Coming soon...`,
    hilloOffice: `*Mexico city, Mexico (HQ)* ;;
        Cto Interior Avenida Río Churubusco 601, Xoco, ;;
        Benito Juárez, 03330 ;; 
        =See on map= ;;
        ;; ;; 
        *Hermosillo, Sonora* ;; 
        Bulevar Abelardo L. Rodríguez & Av. Everardo ;;
        Monroy 51, Centro, 83000 ;;
        =See on map=
        ;; ;;
        *Phoenix, Arizona* ;; 
        Coming soon...`,
    footerHead:
      "^*Ready to get started with INOWU?*^ ;; =Schedule a meeting now=",
    ///DYNAMIC PAGE CONTENT///
    cienpotencia: {
      //TESTIMONIALS//
      body: `"The team was always willing to help." ;; ;;
            INOWU successfully developed a user-friendly site complete with all the functionalities
            that the client required. They remained highly approachable and receptive to feedback and
            suggestions throughout the engagement.`,
      footer: `*Patricio Madrazo* ;; #Co-Founder, _Cien potencia_#`,
      //DISPLAYER CONTENT//
      header: `*Start Your $Journey$ to Becoming a $polygot$ today*`,
      displayerBody: `Academia de Lenguas Internacionales is a web platform offering courses in 8 different languages, complemented by video streaming services to enhance the learning experience and help users become polyglots.`,
      btnText: "$Read the Academia de Lenguas success story$",
    },
    bullground: {
      //TESTIMONIALS//
      body: `"They speak their mind and look for the best solution to solve a business problem." ;; ;;
            The new site has significantly boosted the client's monthly recurring revenue. INOWU is
            not afraid to think outside of the box.`,
      footer: `*Hector* ;; #CMO, _Bullground_#`,
      //DISPLAYER CONTENT//
      header: `*$Latin America’s$ top financial ;; $e-learning$ platform, Bullground*`,
      displayerBody: `Bullground helps students learn about finances, the stock market, and investments – it is 
            considered the number one option for Spanish speakers! Available as a web platform and mobile app.`,
      btnText: "$Read Bullground’s success story$",
    },
    myInfo: {
      //TESTIMONIALS//
      body: `"The team at INOWU has always been ready to listen." ;; ;;
            INOWU has led a successful project.
            They have created an easygoing but professional environment for the client's needs while
            encouraging them to express their concerns.`,
      footer: `*Nicolas Blanco Storz* ;; #App Development Consultant, _My Info App_#`,
    },
    gmEshop: {
      //TESTIMONIALS//
      body: `"A great cost, they always offered discounts on iterations." ;; ;;
            Although the site has not launched yet,
            the website has all the features of an e-commerce site thanks to INOWU's work. The team communicated
            regularly with daily meetings and was flexible with requests.`,
      footer: `*Leonardo Guerrero* ;; #E-Commerce Manager, _GM E-SHOP_#`,
      //DISPLAYER CONTENT//
      header: `*$E-commerce$ platform redesign for GM E-Shop*`,
      displayerBody: `INOWU’s team used principles of UX and UI to create an attractive, highly usable ecommerce 
            platform for electronics retailer GM E-Shop. Click below to read more.`,
      btnText: "$Read the GM E-shop story$",
    },
    cadefi: {
      //TESTIMONIALS//
      body: `"They are very creative in accomplishing tasks that give them."With the new platform,
            the client has noticed several positive results: a 30% increase in retention rate, a dramatic
            reduction in costs, and higher annual revenue.`,
      footer: `*Nancy Avila* ;; #COO, _Cadefi_#`,
      //DISPLAYER CONTENT//
      header: `*$Live workshops$ and e-courses for accountants through $CADEFI$*`,
      displayerBody: `CADEFI is an online platform offering subscription-based online courses for accountants – users 
            can even get certified through the website.`,
      btnText: "$Read more about CADEFI$",
    },
    lgAutopartes: {
      //TESTIMONIALS//
      body: `"The deliverables that we have received So far, it's been a productive partnership.
            The client is impressed with the work done by INOWU, commending them for their timeliness and
            quality outputs.have been great and completed on time."`,
      footer: `*Luis Gerardo Nuñez Alba* ;; #CEO, _LG AUTOPARTES_#`,
      //DISPLAYER CONTENT//
      header: `The best $auto parts products$ searcher in $Mexico$`,
      displayerBody: `LG is a e-commerce that sell auto parts all over Mexico having
            a friendly UI|UX e-commerce that helps users to find products faster.`,
    },
    direxio: {
      //TESTIMONIALS//
      body: `"The final result was as the designers envisioned it." The client gained noteworthy
            leads since INOWU launched the web page.Their design was just as the internal team wanted.
            Meanwhile, the vendor's organized timeline helped maintain comfort throughout the transaction.`,
      footer: `*Gustavo Fernando Barreto Torija* ;; #CFO, _DIREXIO_#`,
    },
    sunum: {
      //TESTIMONIALS//
      body: `"Communication was always effective for any clarification or change for what was needed."
            INOWU delivered the website in time for the launch meeting the client's expectations. The team
            established effective communication and delivery stages were fulfilled on time.`,
      footer: `*Manuel Millones* ;; #CEO, _SUNUM_#`,
    },
    medmex: {
      //DISPLAYER CONTENT//
      header: `*Medmex, a customer-focused app for $medical history$ tracking*`,
      displayerBody: `Medmex allows for clearer communication between patients and physicians, and keeps track of 
            health data fluctuations with easily understandable graphics.`,
      btnText: "$Read the Medmex success story$",
    },
    wmobil: {
      //DISPLAYER CONTENT//
      header: `*WMobil, a business monitoring app for $restaurant owners$*`,
      displayerBody: `WMobil’s intuitive design allows owners to easily monitor discounts, cash flow, credit and debit 
            sales, and tickets in real-time – all from a phone.`,
      btnText: "$Read the WMobil story$",
    },
    academiaLenguas: {
      //DISPLAYER CONTENT//
      header: `The faster way to help a $polyglot$ through a web platform.`,
      displayerBody: `Academia de Lenguas is an academy that focus to teach student from
            cero to polyglot, in this platform users have several tools to help them
            as an extra after and before the classes.`,
    },
  },
  /////////////////////SERVICES SCREEN EN//////////////////////////////
  servicesScreen: {
    titleMain: `*Our team are experts in the $newest technologies.$*`,
    servicesLink: "Read more",
    portfolioLink: "Visit client website",
    customSofDev: {
      head: `*=Custom Software Development=*`,
      body: `Work with a team dedicated to meeting your exact specifications for your custom software.`,
    },
    websiteDev: {
      head: `*=Website Development=*`,
      body: `Own your presence in the digital space with highly functional website development.`,
    },
    mobileAppDev: {
      head: `*=Mobile App Development=*`,
      body: `Connect to your audience anywhere they go with innovative mobile app development.`,
    },
    reactDev: {
      head: `*=React Development=*`,
      body: `Achieve better performance, greater flexibility, and rich user interfaces with ReactJS.`,
    },
  },
  /////////////////////SERVICES PAGE SCREEN EN//////////////////////////////
  servicesPageScreen: {
    ///STATIC PAGE CONTENT///
    subtitle: `*Choosing $INOWU$*`,
    projectLink: `$Estimate project$`,
    ///DYNAMIC PAGE CONTENT///
    customSofDev: {
      //BOTTOM SLIDER//
      sliderHead: `*=Custom Software Development=*`,
      sliderBody: `Work with a team dedicated to meeting your exact specifications for your custom software.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*$Custom software$ development solutions.*`,
      titleBody: `Learn how INOWU’s team creates custom software solutions that ;;
            help you achieve your goals.`,
      title1: `*Why invest in $software development$?*`,
      about1: `Many companies have ideas or requirements that cannot be achieved with 
            a pre-packaged SaaS solution. Though there are a plethora of options available in 
            the SaaS marketplace, there is no guarantee that a “universal” solution will provide 
            you with the exact functionality your project needs.`,
      about2: `Time spent searching for the “perfect” solution can be better spent working 
            with a talented team whose main objective is to provide you with a deliverable that is to 
            your exact specifications. ;; INOWU employs not only experienced developers, but also a team 
            of UX | UI designers – meaning your custom software solution will not only be highly functional, 
            but also highly usable and attractive. ;; Don’t waste time looking for a one-size-fits-all software 
            solution – let INOWU create one for you.`,
      processTitle: `*Our $process$*`,
      headline: `*Choosing INOWU.*`,
      subtext: `Let INOWU help your business by delivering ;;
            professional and functional apps, websites, ;;
            and custom software. Get started today!`,
      moreServices: `*See more of our $awesome services$*`,
      contactBox: `^*Ready to get started? So are we!*^ ;; =Get in touch with INOWU=`,
      //OUR PROCESS SUBTITLES//
      name1: "*Information gathering*",
      description1: `We fully document your processes and agile methodologies in order to understand your ideas and 
            requirements, and begin ideating on how to best display them.`,
      name2: "*Design*",
      description2: `Our design team begins their part – taking elements and best practices of UX | UI into 
            consideration every step of the way.`,
      name3: "*Development*",
      description3: `Now that we know how to make your software solution work for you, and how you would like 
            it to look, it’s time to implement. Our developers will dive into the build process.`,
      name4: "*Testing*",
      description4: `INOWU believes that testing is the most important phase. We assess your solution with 
            both manual and automated workflows, ensuring that everything will be ready in time for 
            your target release date.`,
    },
    websiteDev: {
      //BOTTOM SLIDER//
      sliderHead: `*=Website Development=*`,
      sliderBody: `Own your presence in the digital space with highly functional website development.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*$Website$ development services.*`,
      titleBody: `Migrate your business to digital with highly functional and attractive website development.`,
      title1: `*Why invest in $custom web development$?*`,
      about1: `The world continues to rely more and more heavily on digital platforms, especially due to the 
            effects of the pandemic – this means having an online presence in the form of a website is becoming increasingly 
            vital to the success of businesses.
            ;; ;;
            Efficient web development is about more than just a simple landing page – your website must have all of the necessary 
            functionality that allows users to interact with your business easily and seamlessly. INOWU’s website development gives 
            you a website that is not only fully functional, but can also be continuously updated with new features and widgets as 
            your business grows.`,
      about2: `We can design your website to drive traffic and conversion with features and functionalities designed 
            for usability and appeal. We are experts in turning businesses digital. No matter the starting point, our team is prepared 
            with the knowledge and creativity to recommend the best path for your business to succeed.`,
      processTitle: `*The web development $process$*`,
      headline: `*Why choose INOWU?*`,
      subtext: `INOWU’s teams have over a decade of experience ;;
            in the custom website development industry. ;;
            We can help you!`,
      moreServices: `*Explore other INOWU $services$*`,
      contactBox: `^*Ready to build your website?*^ ;; =Get in touch with INOWU=`,
      //OUR PROCESS SUBTITLES//
      name1: "*Evaluate*",
      description1: `We will work with you to determine the material you need to migrate to digital and recommend the ideal 
            implementation strategy.`,
      name2: "*Conceptualize*",
      description2: `Our UI | UX team will progress to the design phase and document throughout the process.`,
      name3: "*Deliver*",
      description3: `Once we’ve fully aligned with your vision for the website, our development team will deliver the final 
            project on your personal domain.`,
    },
    mobileAppDev: {
      //BOTTOM SLIDER//
      sliderHead: `*=Mobile App Development=*`,
      sliderBody: `Connect to your audience anywhere they go with innovative mobile app development.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*$Custom mobile app$ development.*`,
      titleBody: `Grow your business with a custom, modern app developed by INOWU.`,
      title1: `*Achieve greater reach with $mobile apps$*`,
      about1: `Maintaining relevance in a competitive market involves reaching your audience where it matters most – 
            through mobile apps. Mobile apps allow for improved user experience, on-the-go access, and, in some cases, can replace 
            your website altogether. Upscale your business and reach a broader audience with professional app development.`,
      about2: `Designing an app is not as easy as it looks. The App Store and Play Store have specific policies that 
            can prevent clients from realizing their vision. INOWU can adjust to your needs by implementing tools like Flutter, 
            allowing us to reuse code and create visually appealing mobile apps that are compatible with both iOS and Android devices.`,
      processTitle: `*Our app development $process$*`,
      headline: `*Realize your vision with INOWU.*`,
      subtext: `Mobile apps are taking off more than ever before. ;;
            Work with a company that can help you get it right.`,
      moreServices: `*Other INOWU $services$*`,
      contactBox: `^*Ready to launch your custom app?*^ ;; =Get started with INOWU=`,
      //OUR PROCESS SUBTITLES//
      name1: "*Research & Alignment*",
      description1: `We start by gathering information about the features and designs you want to include in your custom app.`,
      name2: "*Adjust & Adapt*",
      description2: `In order to meet store policies, we work with you to adjust your processes and ensure your app will be compatible 
            on the App Store and Play Store.`,
      name3: "*Design & Develop*",
      description3: `Our UX | UI team will formulate a design for ultimate usability and aesthetics, which will then be passed off to 
            our Flutter development team.`,
      name4: "*Test & Deliver*",
      description4: `Finally, we test the app on iPhone and Android devices to ensure full functionality is achieved before delivering 
            the final product.`,
    },
    reactDev: {
      //BOTTOM SLIDER//
      sliderHead: `*=React Development=*`,
      sliderBody: `Achieve better performance, greater flexibility, and rich user interfaces with ReactJS.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*Development with $ReactJS$.*`,
      titleBody: `ReactJS is a JavaScript library that allows developers to build highly interactive user interfaces.`,
      title1: `*Why is $ReactJS$ a preferred option?*`,
      about1: `Due to its popularity and high usability, many of our clients specify that they’d like to work with ReactJS 
            – this request is music to our ears. Our experienced developers are able to combine the ReactJS framework with other packages, 
            allowing for quicker load times and component-based editing capabilities – modify one thing in one place, and the change is 
            reflected throughout the application or program.`,
      about2: `Many of our first projects were created with ReactJS, lending us the benefit of having ample experience with it. 
            Additionally, INOWU frequently works with stacks that combine ReactJS with other tools, including Firebase, MySQL, and more. Thanks 
            to this, and ReactJS’ component-based capabilities, we can develop agile – more easily and quickly than other companies.`,
      processTitle: `*$Process$ overview*`,
      headline: `*Why choose INOWU?*`,
      subtext: `Working with a development company that ;;
            understands your goals and process is ;; 
            crucial – we do just that.`,
      moreServices: `*How can we $help$?*`,
      contactBox: `^*Ready to start developing?*^ ;; =Get in touch with INOWU today=`,
      //OUR PROCESS SUBTITLES//
      name1: "*Analysis & research*",
      description1: `Our team discusses how we can best problem-solve and accommodate your needs. ReactJS houses libraries that solve 
            some problems, but are not compatible with others, so we take the time to select the ones that fit your requirements best.`,
      name2: "*Resources & prototyping*",
      description2: `At the same time that the first version of the UX | UI is being delivered, an INOWU architect is in charge of installing 
            all of the packages and libraries that will help us develop quicker. For this, we use Typescript and ReactJS.`,
      name3: "*Components & development*",
      description3: `While the UX | UI prototype is being finalized, we analyze which components appear frequently throughout the application. 
            By knowing this, we know which ones can be reused. This is also when the development phase begins.`,
      name4: "*Deliverables & reviews*",
      description4: `INOWU’s development projects run under a Scrum plan – our team provides updated deliverables every two weeks. This gives you 
            visibility into everything we’re doing, as well as allowing us to iterate based on your feedback.`,
      name5: "*Testing & flow*",
      description5: `INOWU views testing as the most important step of any development process. Each component is unit tested, so end-to-end testing 
            is crucial as it allows us to ensure that the flow of the entire application as a whole is correct.`,
      name6: "*Delivery & walkthrough*",
      description6: `Once testing is complete and the application is ascertained to be fully functional, we deliver the finished product to you and 
            make sure you understand every part of your new application and its functionality.`,
    },
  },
  /////////////////////PORTFOLIO SCREEN EN//////////////////////////////
  portfolioScreen: {
    titleMain: `*Discover some of INOWU's $best work$.*`,
    ribbon: `Outsourcing`,
    ribbon_proj: `Project`,
    bullground: {
      head: `*=Bullground=*`,
      body: `INOWU developed a website and mobile app for this financial e-learning platform.`,
    },
    wmobil: {
      head: `*=WMobil=*`,
      body: `INOWU built a fully-functional app for this restaurant business tracking platform.`,
    },
    medmex: {
      head: `*=Medmex=*`,
      body: `INOWU developed an app for this medical history and information tracking platform.`,
    },
    gmEshop: {
      head: `*=GM E-shop=*`,
      body: `INOWU created an ecommerce website with UX and UI considerations for this client.`,
    },
    cadefi: {
      head: `*=CADEFI=*`,
      body: `INOWU built a website for this live accounting workshop and course provider.`,
    },
    lgAutopartes: {
      head: `*=LG Autopartes=*`,
      body: `INOWU helped users find products faster by building an ecommerce platform.`,
    },
    academiaLenguas: {
      head: `*=Academia de Lenguas=*`,
      body: `INOWU provided students with language learning opportunities by building this website.`,
    },
    cienpotencia: {
      head: `*=Cienpotencia=*`,
      body: `INOWU built a website for this platform, offering premium content from expert coaches.`,
    },
    autio: {
      head: `*=autio - You’ve never taken a trip like this=*`,
      body: `INOWU is developing and maintaining the native android app.`,
    },
    herdx: {
      head: `*=HERDX - Tag, Track, Tap=*`,
      body: `INOWU is helping on the flutter app maintenance and developing new features.`,
    },
    neta: {
      head: `*=Tonetip - The Next Generation of Connected Media=*`,
      body: `INOWU helped in developing all the technology of Tonetip helping them with Audio Hyperlink files. `,
    },
    atease: {
      head: `*=Videoremixes - Specialized software platform for DJs=*`,
      body: `INOWU develop the new videoremixes website for increasing customers UI | UX.`,
    },
  },
  /////////////////////PROJECT SCREEN EN//////////////////////////////
  projectScreen: {
    ///STATIC PAGE CONTENT///
    projectLink: `$Get a project estimate$`,
    ///DYNAMIC PAGE CONTENT///
    bullground: {
      //PROJECT SLIDER//
      sliderHead: `*=Bullground=*`,
      sliderBody: `INOWU developed a website and mobile app for this financial e-learning platform.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*The best financial $e-learning$ platform in $Latin America$.*`,
      titleBody: `Bullground is considered to be the top choice in Latin America for online 
            financial education. INOWU designed a web platform and mobile app to help Spanish-speaking 
            students learn about finances, the stock market, and investments.`,
      headline: `*Why work with us?*`,
      subtext: `Whether your project is healthcare, government, ;;
            security, Big Data, or FinTech related, INOWU ;;
            has the resources and expertise to help.`,
      bottomSlider: `*Dive into more of our $best work$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Homepage$*",
      description1: `Browse the last courses you searched on the platform while continuing your 
            current video from the same screen.`,
      name2: "*$Login and signup$*",
      description2: `Users can log in and sign up using Facebook or Google authentication – no 
            account creation necessary.`,
      name3: "*$User ranking$*",
      description3: `Get competitive! INOWU created a scoreboard where users can see how many 
            points other users have earned.`,
      name4: "*$Portfolio recommendation$*",
      description4: `We added a paid feature that gives users portfolio recommendations once they 
            purchase a premium subscription.`,
      name5: "*$Stock market API$*",
      description5: `INOWU used an API that pulls live stock prices each day and pulls them 
            into the site.`,
      name6: "*$Trivia game$*",
      description6: `Users can now battle each other and steal points by participating in 
            head-to-head trivia.`,
      name7: "*$Course pages$*",
      description7: `Each course has a video, along with a description and all required course 
            materials.`,
      name8: "*$Course quizzes$*",
      description8: `Some courses include quizzes that allow users to gain points depending on 
            overall score.`,
      name9: "*$Subscription model$*",
      description9: `Users have an option to subscribe to the platform and unlock premium content.`,
      name0: "*$Mobile app$*",
      description0: `INOWU implemented all of these features into an app. Available on Play Store and App Store.`,
    },
    cienpotencia: {
      //PROJECT SLIDER//
      sliderHead: `*=Cienpotencia=*`,
      sliderBody: `INOWU built a website for this platform, offering premium content from expert coaches.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*High-quality online $courses$ about anything, $for everyone$.*`,
      titleBody: `Cienpotencia is a web platform with various coaches teaching about different subjects. 
            Users can subscribe to individual instructors and view their premium content on demand.`,
      headline: `*Why INOWU?*`,
      subtext: `If you’re looking for a talented, fast-acting team ;;
            for your next development project, you’re in the right place. ;;
            Get started with INOWU today.`,
      bottomSlider: `*Looking for more of our $greatest projects$?*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Functionality$*",
      description1: `Users can navigate the platform, subscribe to individual coaches, and 
            give donations to their favorites.`,
      name2: "*$Donations and subscriptions$*",
      description2: `Subscribe to multiple instructors on one account – all of your subscriptions are stored and manageable.`,
      name3: "*$Job opportunities$*",
      description3: `Users can find job opportunities through Cienpotencia! Uploading your documents and paying the fee is easy.`,
    },
    medmex: {
      //PROJECT SLIDER//
      sliderHead: `*=Medmex=*`,
      sliderBody: `INOWU developed an app for this medical history and information tracking platform.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*Easy-to-use, customer-focused $medical tracking$.*`,
      titleBody: `Medmex allows users to track their health progression, including weight, blood pressure, and other 
            important medical data. Easy sharing capabilities means this information can be easily transferred between 
            users, including patient to doctor transfer.`,
      headline: "*Work with INOWU.*",
      subtext: `From app and website development, to creating ;;
            custom software solutions, INOWU is able to help ;;
            clients in many different industries with their ;;
            development projects.`,
      bottomSlider: `*View more of INOWU’s $best work$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Graphics$*",
      description1: `Users can create personalized graphics with their health data to visualize weight, blood pressure, 
            and other measurement progression.`,
      name2: "*$Authentication$*",
      description2: `In order to access Medmex, users can use Facebook, Google, or Apple authentication.`,
      name3: "*$Shareable profiles$*",
      description3: `Users can share their profiles with physicians via QR code or sending a user code.`,
      name4: "*$Medication reminders$*",
      description4: `Create notifications within the app to remind the user to take their medication.`,
    },
    gmEshop: {
      //PROJECT SLIDER//
      sliderHead: "*=GM E-shop=*",
      sliderBody: `INOWU created an ecommerce website with UX and UI considerations for this client.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*Easy online shopping with an intuitive ;; $e-commerce$ experience.*`,
      titleBody: `GM E-Shop is an online retailer of electronics. INOWU helped them create a fully-functional 
            e-commerce website with user experience and interface considerations.`,
      headline: "*Ready to work with us?*",
      subtext: `Let INOWU help your business by delivering professional ;;
            and functional apps, websites, and custom software. ;;
            Get started today!`,
      bottomSlider: `*See more of INOWU’s $best work$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Intuitive UI | UX$*",
      description1: `INOWU developed a functional but beautiful website with UI and UX considerations.`,
      name2: "*$E-commerce functionality$*",
      description2: `The site is full of ecommerce features: shopping cart, product filter, product 
            specs, and checkout.`,
      name3: "*$Payment method options$*",
      description3: `Users can choose their payment method – PayPal, OXXO, Mercado Pago, or Openpay.`,
      name4: "*$DHL integration$*",
      description4: `When an order is completed, real-time DHL tracking information is sent to the user.`,
    },
    cadefi: {
      //PROJECT SLIDER//
      sliderHead: "*=CADEFI=*",
      sliderBody: `INOWU built a website for this live accounting workshop and course provider.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*Exclusive accounting $workshops$ and $live courses$.*`,
      titleBody: `CADEFI is a provider of online learning for those interested in accounting. INOWU helped them 
            by building a highly interactive web platform for users to gain knowledge and certifications.`,
      headline: "*Work with us!*",
      subtext: `INOWU works with companies in FinTech, health, ;;
            government, security, Big Data, and much more. We’d ;;
            love to help you with your development project.`,
      bottomSlider: `*Discover more of INOWU’s $work$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Streaming server$*",
      description1: `The platform has an integrated streaming server, dividing user bandwidth and decreasing lag times.`,
      name2: "*$Account security$*",
      description2: `Only one user can access an account at a time, improving platform security.`,
      name3: "*$Individual payment options$*",
      description3: `Users can pay for courses with PayPal, Mercado Pago, OXXO, or credit/debit card via Stripe.`,
      name4: "*$Online certifications$*",
      description4: `Upon finishing a course, the user receives a downloadable certificate of completion.`,
    },
    lgAutopartes: {
      //PROJECT SLIDER//
      sliderHead: "*=LG Autopartes=*",
      sliderBody: `INOWU helped users find products faster by building an ecommerce platform.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*$Mexico’s$ top $auto parts$ search platform.*`,
      titleBody: `LG Autopartes came to INOWU looking for an intuitive platform with UX and UI considerations, 
            allowing users to easily search for products and get what they need quicker.`,
      headline: "*Working with INOWU.*",
      subtext: `Our talented team of UX/UI designers and developers ;;
            is able to seamlessly complete projects on time, within budget, ;;
            and to our clients’ exact specifications.`,
      bottomSlider: `*Learn more about our $greatest achievements$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Dynamic car search$*",
      description1: `Users can filter results by make, model, and year, allowing them to search 
            for their product faster.`,
      name2: "*$Robust e-commerce platform$*",
      description2: `With over 10,000 products, INOWU ensured the platform had a strong backend infrastructure.`,
      name3: "*$Blog section$*",
      description3: `The website allows for continual posting of dynamic content, including titles, images, and inputs.`,
      name4: "*$Online bookings$*",
      description4: `Users can book appointments at physical stores, including location, mechanic, and time selection.`,
      name5: "*$Payment integrations$*",
      description5: `Users can pay for their purchase with PayPal, or with their credit or debit card with a Stripe integration.`,
    },
    academiaLenguas: {
      //PROJECT SLIDER//
      sliderHead: "*=Academia de Lenguas=*",
      sliderBody: `INOWU provided students with language learning opportunities by building this website.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*An online learning platform for language $students$.*`,
      titleBody: `Academia de Lenguas is an online academy that helps students learn and master new languages. INOWU added some intuitive 
            features to their online platform, making it easier to use.`,
      headline: "*Working with INOWU.*",
      subtext: `From FinTech, to healthcare, to government, security, ;;
            and Big Data, INOWU’s team is capable of completing any project. ;;
            What are you waiting for?`,
      bottomSlider: `*Want to see more of $our work$?*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Posts and comment sections$*",
      description1: ` Users can post a question about the class, allowing administrators and other students to comment and share their opinions.`,
      name2: "*$Personalized search$*",
      description2: `Robust search functionality allows users to search by theme, and an algorithm helps correct mistakes made during search.`,
      name3: "*$Payment housed in-platform$*",
      description3: `Users can subscribe to the platform, pay with OXXO, credit/debit card, or SPEI, and continue payment through Conekta.`,
      name4: "*$OXXO vouchers$*",
      description4: `If the users chooses to pay with OXXO, a voucher is generated, allowing them to take it to a physical store and use it.`,
    },
    wmobil: {
      //PROJECT SLIDER//
      sliderHead: "*=WMobil=*",
      sliderBody: `INOWU built a fully-functional app for this restaurant business tracking platform.`,
      //////////////////PAGE CONTENT//////////////////
      titleMain: `*Track your $restaurants$ from anywhere, $anytime$.*`,
      titleBody: `Available on the Play Store and App Store, WMobil is a tracking platform created to help restaurant 
            owners monitor their restaurants with real-time data. From discounts, to sales, to cash, debit, or credit 
            transactions – all of this information is in the palm of your hand.`,
      headline: "*Why choose INOWU?*",
      subtext: `Our experienced teams of UX and UI designers ;;
            and developers have the expertise and knowledge ;;
            required to create fully-functional mobile apps, ;;
            websites, and custom software.`,
      bottomSlider: `*Read more about our $best projects$*`,
      //OUR PROCESS SUBTITLES//
      name1: "*$Real-time restaurant sales$*",
      description1: `Users can look at their sales data in real time.
            From cash, to credit and debit, to tips, and more.`,
      name2: "*$Top product and staff data$*",
      description2: `Gain a holistic view of your data, including sorting by top 
            product sales or employee revenue.`,
      name3: "*$Place administration$*",
      description3: `Check customer tickets to verify product sales, or track revenue 
            with ticket totals, in real time.`,
      name4: "*$Reports$*",
      description4: `Generate reports from a set time period to track sales, movement, 
            cancellations, or discounts`,
      name5: "*$Desktop app$*",
      description5: `INOWU translated all of these features into a handy mobile app – 
            track your data on the go!`,
      name6: "*$Web view$*",
      description6: `We created dual-access capabilities with a desktop version of 
            the WMobil platform.`,
      name7: "*$Restaurant subscriptions$*",
      description7: `Officially register your restaurant and download the app onto your mobile, 
            desktop, or laptop!`,
    },
  },
  /////////////////////CONTACT SCREEN EN//////////////////////////////
  contactScreen: {
    title: {
      head: `*Ready to work with us? $Send us a message$!*`,
      subtitle: `*=$Schedule your meeting ;; here$!=*`,
    },
    boxText: {
      name: `Name*`,
      email: `Email*`,
      phone: `Phone*`,
      phoneMsg: `Invalid phone number`,
      phoneMsg2: `Please enter a phone number`,
      phoneMsg3: `Phone number required`,
      project: `Description of project*`,
      reqMsg: `This field is required`,
      emailMsg: `Please enter a valid Email Address`,
      submit: `Submit message`,
      submitMsg: `#Submitting...#`,
    },
    popup: {
      head: `Successful`,
      headErr: `Oh no!`,
      body: `Successfully submitted! We will be communicating with you in the next 24 hours.`,
      bodyErr: `Something went wrong! ;; Try again in a few minutes!`,
      successfulBtn: `Great!`,
      errBtn: `Understood`,
    },
  },
  /////////////////////FOOTER EN//////////////////////////////
  footer: {
    privacy: `*Privacy Policy*`,
    contact: `*Contact*`,
    follow: `*Follow Us*`,
    terms: `*Terms of Service*`,
  },
};
